<template>
    <div v-if="loading" class="loading">Loading...</div>
    <div class="fixed p-2 flex flex-col items-center justify-around bg-cover bg-center bg-no-repeat bg-[url('../assets/background/L.jpg')] h-screen w-screen">
        <div class="h-1/6 py-2">
            <p class="text-center text-orange-500 font-bold xl:text-6xl lg:text-5xl md:text-4xl sm:text-4xl">วิดีโอบริหารสมองสำหรับผู้สูงอายุ</p>
        </div>
        <div class="relative h-4/6 flex justify-center items-center">            
            <video controls :autoplay="autoplay" class="xl:w-[90%] lg:w-3/4 md:w-2/4 sm:w-2/4 border border-lime-400 rounded-lg shadow-lg shadow-amber-400 drop-shadow-lg">
                    <source src="../assets/video/video.mp4" type="video/mp4">                                
            </video>                
        </div>
        <div class="h-1/6 py-6">
            <p class="cursor-pointer px-8 bg-sky-500 text-white font-bold text-4xl rounded-lg shadow-lg hover:ring-4 hover:ring-bg-sky-100" @click="nextToPageCheckpoint()">ไปเล่นเกมกัน >></p>
        </div>
    </div>    
</template>

<script>

export default {
    name: "videoL",
    props: {
        msg: String,        
    },
    data() {
      return {
        autoplay: true
      }
    },
    methods: {
        nextToPageCheckpoint() {
            window.location.href = '/#/checkpoint/';
        }
    }
};
</script>
